import PolicyLayout from '../components/PolicyLayout';

export default function Privacy() {
  return (
    <PolicyLayout title="Privacy Policy">
      <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '-10px', marginBottom: '30px' }}>
        <em>Last updated: November 5, 2025</em>
      </p>

      <h2>1. Introduction</h2>
      <p>
        VirtueSign ("we", "our", or "the app") is an email signature management application for Microsoft Outlook.
        This privacy policy explains how VirtueSign collects, uses, and protects your data.
      </p>

      <h2>2. Data We Collect</h2>
      <p>VirtueSign collects and processes the following data:</p>
      <ul>
        <li><strong>User Profile Information:</strong> Name, email address, job title, department, phone number, and other profile fields from Microsoft 365 (via Microsoft Graph API)</li>
        <li><strong>Email Signature Content:</strong> HTML signature templates and rendered signatures</li>
        <li><strong>Usage Data:</strong> Information about when signatures are fetched and inserted (for analytics)</li>
        <li><strong>Authentication Data:</strong> Microsoft 365 authentication tokens (encrypted and stored securely)</li>
      </ul>

      <h2>3. How We Use Your Data</h2>
      <p>We use your data to:</p>
      <ul>
        <li>Generate personalized email signatures based on your Microsoft 365 profile</li>
        <li>Automatically insert signatures into new email messages</li>
        <li>Provide administrators with user and signature management capabilities</li>
        <li>Improve the app through usage analytics</li>
      </ul>

      <h2>4. Data Storage and Security</h2>
      <ul>
        <li>All data is stored securely in encrypted databases</li>
        <li>Authentication tokens are encrypted using industry-standard encryption</li>
        <li>Data is stored within the EU (if applicable to your deployment)</li>
        <li>We implement appropriate technical and organizational measures to protect your data</li>
      </ul>

      <h2>5. Data Sharing</h2>
      <p>
        VirtueSign does not sell or share your personal data with third parties. 
        Data is only accessed by:
      </p>
      <ul>
        <li>Your organization's administrators (for signature management)</li>
        <li>Microsoft (for authentication via Microsoft 365)</li>
      </ul>

      <h2>6. Data Retention</h2>
      <p>
        We retain your data as long as your organization maintains an active VirtueSign account. 
        When an account is deleted, all associated data is permanently removed within 30 days.
      </p>

      <h2>7. Your Rights</h2>
      <p>Under GDPR and other privacy laws, you have the right to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Object to data processing</li>
        <li>Data portability</li>
      </ul>
      <p>Contact your organization's administrator or Virtue ApS to exercise these rights.</p>

      <h2>8. Children's Privacy</h2>
      <p>
        VirtueSign is intended for business use and not directed at children under 16. 
        We do not knowingly collect data from children.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this privacy policy from time to time. 
        Changes will be posted on this page with an updated revision date.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        For questions about this privacy policy or VirtueSign's data practices, contact:
      </p>
      <p>
        <strong>Virtue ApS</strong><br />
        Email: <a href="mailto:privacy@virtue.dk">privacy@virtue.dk</a><br />
        Website: <a href="https://virtue.dk">https://virtue.dk</a>
      </p>
    </PolicyLayout>
  );
}
